module.exports = __webpack_public_path__ + "static/media/travel5.e6ad2482.jpg";